import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { UrgencyBar } from './UrgencyBar';
import { PRICE, OLD_PRICE } from '../data/content';
const PRODUCT_BREAKDOWN = [{
  value: '7',
  label: 'módulos del sistema'
}, {
  value: '11',
  label: 'bonos incluidos'
}, {
  value: '1',
  label: 'programador WOD exclusivo'
}];
const TRAINING_RESOURCES = ['+60 variantes de rutinas A/B/C para rotar tus clases', '23 ejercicios y drills en 4 plantillas de sesión de 60 min', '3 macrociclos de 12 semanas: 36 semanas de programación', '3 tests físicos para la evaluación inicial', '9 ejercicios de movilidad y 13 adaptaciones por estación', 'Programador de WOD según objetivo, nivel y equipamiento disponible'];
const PAYMENT_METHODS_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/4c163974-3f2a-4e31-8bc0-f9fc4a1126a4.jpg';
export function FinalOffer() {
  return <section id="comprar" className="scroll-mt-4 px-5 py-12" data-id="element-86" data-mp="247szr7xrdqm6">
      <div className="mx-auto max-w-md" data-id="element-87" data-mp="1qibauell44n">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-88" data-mp="1rjob4f6c0p0">
          Optimiza meses de tu gimnasio,{' '}
          <span className="text-[#F5C518]" data-id="element-89" data-mp="bn3fxempgd7y">en una tarde</span>
        </h2>

        <div className="mt-6 overflow-hidden rounded-2xl border border-[#F5C518]/40 bg-[#111]" data-id="element-90" data-mp="gmpt5o2j9tgr">
          <div className="p-5" data-id="element-91" data-mp="kob24yby5nlo">
            <UrgencyBar data-id="element-92" data-mp="kp2xc81mtjbf" />

            {/* Order summary */}
            <div className="mt-5 rounded-xl border border-white/10 bg-black/40 p-4" data-id="element-93" data-mp="kmgps8eqr3t7">
              <div className="flex items-start justify-between gap-3" data-id="element-94" data-mp="plb8zbgmeudu">
                <div data-id="element-95" data-mp="ufffxupvz2ex">
                  <h3 className="font-oswald text-sm font-700 uppercase tracking-wide text-white" data-id="element-96" data-mp="ug7dhb31na7u">
                    Todo lo que te llevas hoy
                  </h3>
                  <p className="mt-1 text-[12px] leading-snug text-neutral-400" data-id="element-97" data-mp="14dbtet6aq9g7">
                    Un pack completo para programar, evaluar y adaptar tus clases.
                  </p>
                </div>
                <span className="shrink-0 rounded-lg border border-[#F5C518]/40 bg-[#F5C518]/10 px-2.5 py-1.5 text-center font-oswald text-xs font-700 uppercase leading-tight text-[#F5C518]" data-id="element-98" data-mp="35fba9tlvpcjb">
                  19 productos
                </span>
              </div>

              <div className="mt-4 grid grid-cols-3 gap-2" aria-label="Desglose de los 19 productos incluidos" data-id="element-99" data-mp="39flccv6jvisw">
                {PRODUCT_BREAKDOWN.map(item => <div key={item.label} className="rounded-lg border border-white/10 bg-white/[0.03] px-2 py-2.5 text-center" data-id="element-100" data-mp="3o6ubbuwcegip">
                    <p className="font-anton text-2xl leading-none text-[#F5C518]" data-id="element-101" data-mp="10tlbptzewd3">{item.value}</p>
                    <p className="mt-1 font-oswald text-[10px] font-600 uppercase leading-tight tracking-wide text-neutral-300" data-id="element-102" data-mp="3t3kpudsi1420">
                      {item.label}
                    </p>
                  </div>)}
              </div>

              <div className="mt-4 border-t border-white/10 pt-4" data-id="element-103" data-mp="1yrw7e1n26jcv">
                <p className="font-oswald text-xs font-700 uppercase tracking-wide text-white" data-id="element-104" data-mp="1olwedqj7z7bi">
                  Desglose de recursos prácticos
                </p>
                <ul className="mt-3 space-y-2.5" data-id="element-105" data-mp="1ewcqu7kkapab">
                  {TRAINING_RESOURCES.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-neutral-300" data-id="element-106" data-mp="1jv66o6nbmsdn">
                      <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-[#F5C518]" data-id="element-107" data-mp="14xnhj36qed5o" />
                      <span data-id="element-108" data-mp="19xrread4w9mx">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-4 border-t border-white/10 pt-4" data-id="element-109" data-mp="vyijrz2zunuk">
                <div className="flex items-end justify-center gap-3" data-id="element-110" data-mp="10wabot3n29yr">
                  <span className="font-oswald text-xl text-neutral-500 line-through" data-id="element-111" data-mp="10yo9h9ppe0a0">
                    {OLD_PRICE}
                  </span>
                  <div className="flex flex-col items-center" data-id="element-112" data-mp="2vauvz4o1s3hm">
                    <span className="mb-1 rounded-full bg-[#F5C518] px-2.5 py-0.5 font-oswald text-[10px] font-700 uppercase tracking-[0.12em] text-black" data-id="element-113" data-mp="2v88kwv1y75un">
                      Pago único
                    </span>
                    <span className="font-anton text-4xl leading-none text-[#F5C518]" data-id="element-114" data-mp="l9w0lea0bydo">
                      {PRICE}
                    </span>
                  </div>
                </div>
                <p className="mt-1 text-center text-[12px] text-neutral-400" data-id="element-115" data-mp="c9hdqaheab82">
                  Pago único · Acceso inmediato · Los 12 bonos incluidos hoy
                </p>
              </div>
            </div>

            <div className="mt-5" data-id="element-116" data-mp="2jej65umkp7m">
              <BuyButton data-id="element-117" data-mp="2kg02qybo5x9" />
            </div>

            <div className="mt-4 text-center" data-id="element-118" data-mp="3tpz8nl517p2j">
              <p className="text-[10px] font-600 uppercase tracking-[0.12em] text-neutral-500" data-id="element-119" data-mp="3trabniqnkssl">
                Métodos de pago aceptados
              </p>
              <img src={PAYMENT_METHODS_IMAGE} alt="Visa, Mastercard, American Express y Apple Pay" className="mx-auto mt-2 h-auto w-full max-w-[280px] rounded-lg bg-white" data-id="element-120" data-mp="3kparihkcd8lf" />
            </div>

            <div className="mt-4 flex items-center justify-center gap-2 text-[12px] text-neutral-400" data-id="element-121" data-mp="254s0nk3el6og">
              <ShieldCheckIcon className="h-4 w-4 text-[#F5C518]" data-id="element-122" data-mp="298gdah6w6sgk" />
              Compra 100% segura · Entrega inmediata en tu email
            </div>
          </div>
        </div>
      </div>
    </section>;
}